var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItalic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Italic_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 24052",
    transform: "translate(526 261)",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-526 -261)",
    clipPath: "url(#Italic_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 24051",
    width: 20,
    height: 4,
    rx: 2,
    transform: "rotate(-70 467.514 -239.53)"
  }))));
}
export default SvgItalic;